import styled from 'styled-components';

import MuiContainer from '@material-ui/core/Container';

export const CustomContainer = styled(MuiContainer)`
  padding: ${({ theme }) => theme.spacing(3)}px;
`;
